"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryMetricsType = exports.RegressionMetricsType = exports.ThresholdOptimizeCategory = exports.THRESHOLDS_SIZE = exports.THRESHOLD_STATUS = void 0;
var THRESHOLD_STATUS;
(function (THRESHOLD_STATUS) {
    THRESHOLD_STATUS[THRESHOLD_STATUS["IDLE"] = 0] = "IDLE";
    THRESHOLD_STATUS[THRESHOLD_STATUS["UPDATING"] = 1] = "UPDATING";
})(THRESHOLD_STATUS = exports.THRESHOLD_STATUS || (exports.THRESHOLD_STATUS = {}));
/**
 * Helper functions from EinsteinDataDiscovery/src/components/metrics/thresholdevaluation/ThresholdEvaluation.js
 * to calculate the metric classification etc
 */
exports.THRESHOLDS_SIZE = 1000;
var ThresholdOptimizeCategory;
(function (ThresholdOptimizeCategory) {
    ThresholdOptimizeCategory["CUSTOM"] = "Custom";
    ThresholdOptimizeCategory["ACCURACY"] = "Accuracy";
    ThresholdOptimizeCategory["PRECISION"] = "Precision";
    ThresholdOptimizeCategory["F1SCORE"] = "F1 Score";
    ThresholdOptimizeCategory["INFORMEDNESS"] = "Informedness";
    ThresholdOptimizeCategory["MARKEDNESS"] = "Markedness";
    ThresholdOptimizeCategory["MCC"] = "MCC";
})(ThresholdOptimizeCategory = exports.ThresholdOptimizeCategory || (exports.ThresholdOptimizeCategory = {}));
exports.RegressionMetricsType = {
    MAE: 'MAE',
    MSE: 'MSE',
    RMSLE: 'RMSLE',
    RMSE: 'RMSE',
};
exports.BinaryMetricsType = {
    F1: 'F1',
    PRECISION: 'Precision',
    RECALL: 'Recall',
    ACCURACY: 'Accuracy',
    MCC: 'MCC',
    INFORMEDNESS: 'Informedness',
    MARKEDNESS: 'Markedness',
    GINI: 'GINI',
};
//# sourceMappingURL=ModelMetrics.js.map